import {
  GOTO_STEP,
  SUBMIT_ENTITY_FORM,
  SUBMIT_BUSINESS_INFO_FORM,
  SUBMIT_BANK_INFO_FORM,
  SUBMIT_BUSINESS_DOCUMENT_FORM,
  BUSINESS_DATA,
  KYB_DATA,
  UPLOAD_FILE,
  ID_CARD,
  KYB_BANK_DATA,
  RESET_CITY_DROPDOWN,
  RESET_KECAMATAN_DROPDOWN,
  RESET_ZIPCODE_DROPDOWN,
  KYB_IDENTITY_DATA,
  CONFIRM_REVIEW,
  NPWP_IMAGE,
} from './constants';

export function goToStep(step, editMode) {
  return { type: GOTO_STEP, payload: { step, editMode } };
}

export function confirmReview() {
  return { type: CONFIRM_REVIEW };
}

export function uploadFile(data) {
  return { type: UPLOAD_FILE, payload: { data } };
}

export function submitEntityForm({
  business_entity_type,
  businessId,
  editMode,
}) {
  return {
    type: SUBMIT_ENTITY_FORM,
    payload: {
      data: { business_entity_type },
      businessId,
      editMode,
    },
  };
}

export function submitBusinessInfoForm(data) {
  return { type: SUBMIT_BUSINESS_INFO_FORM, payload: data };
}

export function submitBankInfoForm(data) {
  return { type: SUBMIT_BANK_INFO_FORM, payload: data };
}

export function submitBusinessDocumentForm(data) {
  return { type: SUBMIT_BUSINESS_DOCUMENT_FORM, payload: data };
}

export function businessData(data) {
  return { type: BUSINESS_DATA, payload: data };
}

export function kybData(data) {
  return { type: KYB_DATA, payload: { data } };
}

export function kybBankData(data) {
  return { type: KYB_BANK_DATA, payload: { data } };
}

export function kybIdentityData(data) {
  return { type: KYB_IDENTITY_DATA, payload: { data } };
}

export function IdCardData(data) {
  return { type: ID_CARD, payload: data };
}

export function resetKybCityDropdown() {
  return { type: RESET_CITY_DROPDOWN };
}

export function resetKybKecamatanDropdown() {
  return { type: RESET_KECAMATAN_DROPDOWN };
}

export function resetKybZipcodeDropdown() {
  return { type: RESET_ZIPCODE_DROPDOWN };
}

export function npwpImageData(data) {
  return { type: NPWP_IMAGE, payload: data };
}
